/**
 * 애플리케이션 라우트 경로 상수
 * 모든 라우트 경로를 한 곳에서 관리하여 일관성 유지 및 유지보수 용이
 */
// 세션 타임아웃 시간 (30분 = 1800000ms)
export const SESSION_TIMEOUT = 30 * 60 * 1000;
// 활동 업데이트 최소 간격 (5분 = 600000ms)
export const MIN_UPDATE_INTERVAL = 5 * 60 * 1000;
export const SESSION_NAME = 'cworks-auth-storage';
// 메인 라우트
export const ROUTES = {
  // 기본 페이지
  HOME: '/',
  AUTH: '/auth',
  SIGNIN: '/signin',
  SIGNUP: '/signup',
  PASSWORD_RESET: '/resetpw',
  PASSWORD_FORGOT_EMAIL: '/resetpw/email',
  ADMIN_NOTICE: '/admin-notice',
  PAYMENT_CALLBACK: '/payment/callback',
  
  // 대시보드 관련
  DASHBOARD: {
    ROOT: '/',
    EMPLOYEE: {
      LIST: '/employee/list',
      UPLOAD: '/employee/upload',
      DELETE: '/employee/delete',
    },
    USER: {
      MANAGEMENT: '/user/manage',
    },
    // 설정 관련
    SETTINGS: {
      META: '/settings/meta',
    },
    // 구독 관련
    SUBSCRIPTION: {
      LIST: '/order/list',
      DETAIL: '/order/detail',
    },
    PRICING: '/pricing',
  },
  
  // 에러 페이지
  ERROR: {
    FORBIDDEN: '/error/403',
    NOT_FOUND: '/error/404',
    SERVER_ERROR: '/error/500',
  },
};

// 리다이렉트 및 네비게이션에 자주 사용되는 경로
export const NAVIGATION = {
  DEFAULT_AFTER_LOGIN: ROUTES.DASHBOARD.EMPLOYEE.LIST,
  DEFAULT_AFTER_LOGOUT: ROUTES.SIGNIN,
  SHOP_ADMIN_NOTICE: ROUTES.ADMIN_NOTICE,
  DEFAULT_ERROR_REDIRECT: ROUTES.ERROR.NOT_FOUND,
};

export default ROUTES;
